<template>
  <v-dialog width="350px" persistent v-model="editDialog" class="editDialogsRow">
    <v-card-text class="pa-0" slot="activator">
      Add Indication
      <v-icon class="text-xs-right">add</v-icon>
    </v-card-text>
    <v-card>
  <v-container class="mt-0">
    <v-layout row wrap justify-center>
      <v-flex xs12 sm6 offset-sm3 >
        <h4>Create a new Indication</h4>
      </v-flex>
    </v-layout>
    <v-layout row wrap justify-center>
      <v-flex xs12 sm6 offset-sm3>
        <form action="" @submit.prevent="onCreateIndication">
          <v-layout row>
            <v-flex xs12 sm6>
            <v-text-field
              name="indicationName"
              label="Name"
              v-model="indicationName"
              id="indicationName"
              single-line
              required
            ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12 sm6>
              <v-btn depressed class="grey lighten-1 white--text" @click="editDialog = false">Cancel</v-btn>
              <v-btn depressed class="white--text cyan " :disabled="!formIsValid" type="submit">Save</v-btn>
            </v-flex>
          </v-layout>
        </form>
      </v-flex>
    </v-layout>
  </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data () {
    return {
      editDialog: false,
      indicationName: '',
      dialog: false
    }
  },
  props: ['id'],
  computed: {
    indication () {
      return this.$store.getters.loadedIndication(this.id)
    },
    indications () {
      return this.$store.getters.loadedIndications
    },
    formIsValid () {
      return this.indicationName !== ''
    }
  },
  methods: {
    onCreateIndication () {
      if (!this.formIsValid) {
        return
      }
      const indicationData = {
        title: this.indicationName
      }
      this.$store.dispatch('createIndication', indicationData)
      this.$router.push('/indications')
    }
  }
}
</script>




// WEBPACK FOOTER //
// CreateIndication.vue?6687c2a0